export default "__VITE_ASSET__CBOGfa$u__"